import { Button, FormControlLabel, Radio, RadioGroup, TextField, Select, MenuItem, FormControl } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import React, { useEffect, useRef, useState } from 'react';
import toast from 'react-hot-toast';
import { useHistory, useLocation } from "react-router-dom";
import '../index.css';
import http from "../services/httpService";
import handleSubmitValidation from '../utils/handleSubmitValidation';
import handleValidation from '../utils/handleValidations';
import { getToday, investmentDetailsPath, investmentPath, prospectDetailsPath, prospectPath } from "../utils/varialbles";
//import MenuItem from '@material-ui/core/MenuItem';
//import FormControl from '@material-ui/core/FormControl';


const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        paddingTop: theme.spacing(2),
        textAlign: 'left',
        color: theme.palette.text.primary,
    },
    submitButton: {
        marginTop: theme.spacing(5),
        marginBottom: theme.spacing(10),


    },
    gridDevider: {
        marginTop: theme.spacing(6),
        textAlign: 'left',
        color: theme.palette.text.primary,
    },
    lableColor: {
        color: "#393939"
    },
    select: {
        height: 36,
        minWidth: 235,

    },
    mobileCode: {
        height: 36,
    },
    radio: {
        '&$checked': {
            color: '#57bf74'
        }
    }, reviewButton: {
        borderRadius: "20px",
        border: "1px solid #2835D5",
        opacity: 1,
        textAlign: "right"
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 235,
    },
    checked: {}

}));
function InvestAddpayment() {
    let history = useHistory();
    //const [formObject, setFromObject] = useState({});
    // (formObject);
    //const [lookupFile, setLookupFile] = useState(null);   
    // (lookupFile); 
    const [quantityDisable, setQuantityDisable] = useState(false);
    const classes = useStyles();
    const location = useLocation();
    const myparam = location.state;
    const fileInputRef = useRef(null)
    const [form, setForm] = useState({
        cust_id: "",
        firstname: "",
        lastname: "",
        state: "",
        payment_id: "",
        service_type: "",
        quantity: "",
        amount: "",
        date: "",
        proof: ""
    });
    const { cust_id, firstname, lastname, state, payment_id, service_type, quantity, amount, date, proof } = form
    // (form);
    const columns = [
        { "value": 'firstname', "imp": false, "label": 'First Name', minWidth: 150, "filedType": "text", isDisable: false },

        { "value": 'lastname', "imp": false, "label": 'Last Name', minWidth: 150, "filedType": "text", isDisable: false },

        { "value": 'state', "imp": false, "label": 'State', minWidth: 150, "filedType": "dropDown", isDisable: false },

        { "value": 'service_type', "imp": true, "label": 'Subscription Type', minWidth: 170, "filedType": "radio", "options": [{ "label": "Savart X Plan", "value": "X" }, { "label": "Investment Requset", "value": "A" }, { "label": "Investment Review", "value": "R" }] },

        { "value": 'quantity', "imp": true, "label": 'Quantity', minWidth: 150, "filedType": "number", isDisable: true },

        { "value": 'amount', "imp": true, "label": 'Subscription Amount', minWidth: 150, "filedType": "number" },

        { "value": 'date', "imp": true, "label": 'Subscription Date', minWidth: 150, "filedType": "date" },

        // { "value": 'discount_type', "imp": true, "label": 'Payment Id', minWidth: 150, "filedType": "radio", "options": [{ "label": "Custom", "value": "Custom" }, { "label": "Student", "value": "Student" }, { "label": "Farmer", "value": "Farmer" }, { "label": "Military", "value": "Military" }, { "label": "Micro-Investor", "value": "Micro-Investor" }] },

        { "value": 'payment_id', "imp": true, "label": 'Payment Id', minWidth: 150, "filedType": "text" },

        { "value": 'proof', "imp": true, "label": 'Subscription proof', minWidth: 150, "filedType": "file" },

        // { "value": 'reason', "imp": true, "label": 'Reason', minWidth: 150, "filedType": "textarea", multiline: true, rows: 5 },
    ];
    // const validations = {

    //     "service_type": {
    //         conditions: {
    //             "required": true
    //         }, "message": "This Field is required!", "valid": true, "changed": false
    //     },
    //     "quantity": {
    //         conditions: {
    //             "required": true,"minValue":1
    //         }, "message": "This Field is required!", "valid": true, "changed": false
    //     },
    //     "reason": {
    //         conditions: {
    //             "required": true, "maxLength": 1000
    //         }, "message": "Maximum 1000 character Allowed.!", "valid": true, "changed": false
    //     },
    //     "date": {
    //         conditions: {
    //             "required": true,"minDate":getToday(),"pattren":/^\d{4}-\d{2}-\d{2}$/
    //         }, "message": "Maximum 1000 character Allowed.!", "valid": true, "changed": false
    //     },
    //     "amount": {
    //         conditions: {
    //             "required": true, "minValue": 10,
    //         }, "message": "Maximum 20 character Allowed.!", "valid": true, "changed": false
    //     },
    //     "proof": {
    //         conditions: {
    //             "required": true
    //         }, "message": "Proof is required!", "valid": true, "changed": false
    //     },
    //     "state": {
    //         conditions: {
    //             "required": true
    //         }, "message": "state is required!", "valid": false, "changed": false
    //     },
    // }
    //const [validationState, setValidationState] = useState(validations)
    // const gotoProspectDetails = () => {
    //     if (myparam && myparam.cust__id) {
    //         // history.push({
    //         //     "pathname": prospectDetailsPath, state: myparam
    //         // });
    //     } else if (myparam && myparam.customer_id) {
    //         // history.push({
    //         //     "pathname": investmentDetailsPath, state: myparam
    //         // });
    //     }
    // }

    // useEffect(() => {
    //     if (myparam && (myparam.cust__id || myparam.customer_id)) {
    //         setFromObject(form)
    //     }
    //      else {
    //         gotoProspectDetails()
    //     }

    // }, [])
    const handleChange = (event) => {
        //alert("form field change");
        //let name = event.target.name;
        ///let value = event.target.value;
        setForm({ ...form, [event.target.name]: event.target.value });
        //let valid = true;
        //let validStateTemp = { ...validationState }
        //let isSavartX = false;
        if (event.target.name == "service_type" && event.target.value === "X") {
            setQuantityDisable(true);
            //isSavartX = true;
        } else if (event.target.name == "service_type" && event.target.value !== "X") {
            setQuantityDisable(false);
        }

    }
    const handleFileChange = (event) => {
        alert("file received");

    }
    const handleSubmit = (event) => {
        alert("submitted");
    }

    const [showsSatesList, setShowStateList] = useState([]);
    // (showsSatesList);
    useEffect(() => {
        http.get("/statesList").then(res => {
            // (res);
            // (res.data.Data);
            setShowStateList(res.data.Data);
        }).catch(err => {
            // (err);
        });
    }, []);

    return (

        <Grid container component="main" className={"pb30"}>

            <Grid item xs={12} sm={5} md={5} >
                {/* <Button variant="outlined" color="default" startIcon={<ArrowBackIosIcon />} onClick={gotoProspectDetails}>Back</Button> */}
            </Grid>
            <Grid item xs={12} sm={5} md={5} className="mt30">
                <Typography color="textPrimary" variant="h5" >Add Payment</Typography>
            </Grid>
            <Grid container style={{ marginTop: 30 }}>
                {/* {
                    columns.map(question => {
                        return ( */}
                <Grid container className={classes.paper}>
                    <Grid item xs={12} sm={2} md={2} className={"formLable"}>
                        {/* <InputLabel className={classes.lableColor} id={question.label} style={{ paddingTop: "5px" }}>{question.label}
                                        {question.imp && <span style={{color: 'red', fontSize: '1.2rem', marginLeft: '0.2rem'}}>*</span>}
                                    </InputLabel> */}
                    </Grid>

                    {/* <Grid item lg={6} md={6} sm={6} xs={12}>{question.filedType === "select" ?  }>

                                </Grid> */}
                    {/* value={formObject[question.value] } name={question.value} onChange={handleChange} disabled={question.isDisable && quantityDisable} */}
                    {/* 
                                <Grid item lg={6} md={6} sm={6} xs={12}>
                                {question.filedType === "text" ?  
                                    <TextField label="Enter" variant="outlined" value={question.value} name={question.value} onChange={handleChange} style={{ width: "300px" }} /> :

                                    question.filedType === "number"?  
                                    <TextField label="Enter" variant="outlined" value={question.value}  disabled={question.isDisable && quantityDisable} name={question.value} onChange={handleChange} style={{ width: "300px" }} type="number"/> :

                                    question.filedType === "file" ?
                                <>
                                    <input
                                                ref={fileInputRef}
                                                onChange={handleFileChange}
                                                type="file"
                                                style={{ display: "none" }}
                                                multiple={false}
                                                accept=".png,.PNG,.JPEG,.jpeg,.jpg,.JPG"
                                            />
                                            <Button startIcon={<AddCircleOutlineIcon />} variant="outlined" className={classes.reviewButton} color="primary">Choose File</Button>
                                            <span className="fileLable">{lookupFile && lookupFile.name ? lookupFile.name : "No file chosen"}</span> 
                                            </> 
                                            : 
                                            question.filedType === "dropDown" ?
                                                        <FormControl  variant="outlined" className={classes.formControl}>
                                                         <InputLabel id="state">State</InputLabel>
                                                            <Select
                                                                labelId="state"
                                                                id="state"
                                                                value={question.value}
                                                                name={question.value}
                                                                onChange={handleChange}
                                                                >
                                                                {showsSatesList.map(item =>
                                                                    <MenuItem value={item}>{item}</MenuItem>
                                                                )}
                                                                
                                                               
                                                            </Select>
                                                        </FormControl>
                                                        :
                                                        (question.filedType === "date") ? <TextField
                                                            id="datePickerId"
                                                            label="Select Date"
                                                            type="date"
                                                            defaultValue="07:30"
                                                            variant="outlined"
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                            format="dd-mm-yyy"
                                                            value={question.value}
                                                            onChange={handleChange}
                                                            InputProps={{inputProps: { min: getToday()} }}
                                                            name={question.value}                                                
                                                        />
                                            :
                                            question.filedType === "radio" ?
                                        <><RadioGroup row aria-label="position" name={question.value} defaultValue="A" value={question.value ? question.value : "A"} onChange={handleChange}>
                                            {
                                                question.options.map(option => {
                                                    return (
                                                        <FormControlLabel
                                                            control={<Radio classes={{ root: classes.radio, checked: classes.checked }} value={option.value} />}
                                                            label={option.label}
                                                            labelPlacement="end"
                                                        />
                                                    )
                                                })

                                            }
                                        </RadioGroup>
                                        </>

                                    : ""
                                }
                                </Grid> */}
                    <Grid item lg={6} md={6} sm={6} xs={12}>

                        <Grid item lg={6} md={6} sm={6} xs={12}>
                            <InputLabel>First Name</InputLabel>
                            <TextField label="Enter" variant="outlined" value={firstname} name="firstname" onChange={handleChange} style={{ width: "300px" }} />
                        </Grid>
                        <br />
                        <Grid item lg={6} md={6} sm={6} xs={12}>
                            <InputLabel>First Name</InputLabel>
                            <TextField label="Enter" variant="outlined" value={lastname} name={lastname} onChange={handleChange} style={{ width: "300px" }} />
                        </Grid>
                        <br />
                        <Grid item lg={6} md={6} sm={6} xs={12}>
                            <InputLabel>First Name</InputLabel>
                            <FormControl variant="outlined" className={classes.formControl}>
                                <InputLabel id="state">State</InputLabel>
                                <Select
                                    labelId="state"
                                    id="state"
                                    value={state}
                                    name={state}
                                    onChange={handleChange}
                                    style={{ width: "300px" }}
                                >
                                    {showsSatesList.map(item =>
                                        <MenuItem value={item}>{item}</MenuItem>
                                    )}
                                </Select>
                            </FormControl>
                        </Grid>
                        <br />
                        <Grid item lg={6} md={6} sm={6} xs={12}>
                            <InputLabel>First Name</InputLabel>
                            <FormControl variant="outlined" className={classes.formControl}>
                                <InputLabel id="state">State</InputLabel>
                                <Select
                                    labelId="state"
                                    id="state"
                                    value={service_type}
                                    name={service_type}
                                    onChange={handleChange}
                                    style={{ width: "300px" }}
                                >
                                    <MenuItem value="X">Savart X</MenuItem>
                                    <MenuItem value="A">Investment Request</MenuItem>
                                    <MenuItem value="S">Investment Review</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <br />
                        <Grid item lg={6} md={6} sm={6} xs={12}>
                            <InputLabel>First Name</InputLabel>
                            <TextField label="Enter" variant="outlined" value={quantity} name={quantity} onChange={handleChange} style={{ width: "300px" }} type="number" />
                        </Grid>
                        <br />
                        <Grid item lg={6} md={6} sm={6} xs={12}>
                            <InputLabel>First Name</InputLabel>
                            <TextField label="Enter" variant="outlined" value={amount} name={amount} onChange={handleChange} style={{ width: "300px" }} type="number" />
                        </Grid>
                        <br />
                        <Grid item lg={6} md={6} sm={6} xs={12}>
                            <InputLabel>First Name</InputLabel>
                            <TextField variant="outlined" value={date} name={date} onChange={handleChange} style={{ width: "300px" }} type="date" />
                        </Grid>
                        <br />
                        <Grid item lg={6} md={6} sm={6} xs={12}>
                            <InputLabel>First Name</InputLabel>
                            <TextField label="Enter" variant="outlined" value={payment_id} name={payment_id} onChange={handleChange} style={{ width: "300px" }} type="text" />
                        </Grid>
                    </Grid>
                </Grid>
                {/* )
                    }
                    ) 
                }*/}
            </Grid>
            <Grid container className={classes.submitButton}>
                <Grid item xs={false} sm={2} md={2} >

                </Grid>


                <Grid item xs={3} sm={2} md={2} >
                    <Button variant="contained" color="primary" onClick={handleSubmit}>Add payment</Button>
                </Grid>
            </Grid>
        </Grid>
    )

}


export default InvestAddpayment;